import { createContext } from 'react';
export const TableLayoutContext = createContext('table');
export const TableLayoutContextProvider = TableLayoutContext.Provider;
export const TableLayoutContextConsumer = TableLayoutContext.Consumer;
